import { createListenerMiddleware, createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { readStorageValue, saveStorageValue } from 'hooks/use-storage/use-storage.utils';
import { RootState } from 'store/root.types';

export const devtoolsSliceName = 'devtools';

const getInitialState = () =>
  readStorageValue<{
    isLoggedIn: boolean;
  }>({ storageKey: devtoolsSliceName, fallbackValue: { isLoggedIn: false } });

export const devtoolsSlice = createSlice({
  name: devtoolsSliceName,
  initialState: getInitialState(),
  reducers: {
    setLoggedIn(state, { payload: { isLoggedIn } }: PayloadAction<{ isLoggedIn: boolean }>) {
      state.isLoggedIn = isLoggedIn;
    },
    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export type DevtoolsSlicePayload = ReturnType<typeof devtoolsSlice.getInitialState>;
export default devtoolsSlice.reducer;
export const { setLoggedIn, reset } = devtoolsSlice.actions;

export const selectIsLoggedIn = (state: RootState): boolean => {
  return state[devtoolsSliceName].isLoggedIn;
};

export const devtoolsListenerMiddleware = createListenerMiddleware();
devtoolsListenerMiddleware.startListening({
  matcher: isAnyOf(setLoggedIn),
  effect: (action, listenerApi) => {
    saveStorageValue({ storageKey: devtoolsSliceName, value: (listenerApi.getState() as RootState)[devtoolsSliceName] });
  },
});
